import Unidade1 from "./../assets/images/Unidade-11.png";
import Unidade2 from "./../assets/images/Unidade-22.png";
import Unidade3 from "./../assets/images/Unidade-33.png";
import Unidade4 from "./../assets/images/Unidade-44.png";

export const unidadesData = [
  {
    id: 1,
    nome: "Unidade I",
    tituloPagina: "A SEDE",
    descricao: "A Sede principal ocupa uma área de cerca de 1.400 m²...",
    telefone: "(85) 3223-4522",
    endereco: "Rua Papi Junior 1225, Rodolfo Teófilo, Fortaleza/CE",
    imagemDetalhe: Unidade1,
    mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.285343638427!2d-38.55585728991002!3d-3.747906796210223!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c74969884c51d1%3A0xd4cca582b1a32d43!2sR.%20Papi%20J%C3%BAnior%2C%201225%20-%20Rodolfo%20Te%C3%B3filo%2C%20Fortaleza%20-%20CE%2C%2060430-235!5e0!3m2!1spt-BR!2sbr!4v1739714969740!5m2!1spt-BR!2sbr",
    link: "https://tour.meupasseiovirtual.com/view/JNXevFNdWUM",
  },
  {
    id: 2,
    nome: "Unidade II",
    tituloPagina: "UNIDADE II - INTELECTUAL",
    descricao: "A Sede principal ocupa uma área de cerca de 1.400 m²...",
    telefone: "(85) 3223-4522",
    endereco: "Rua Papi Junior 1225, Rodolfo Teófilo, Fortaleza/CE",
    imagemDetalhe: Unidade2,
    mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.292955802609!2d-38.55708728991016!3d-3.746234096211922!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c749696b0b6afd%3A0x426545fc1c7ec0e5!2sR.%20Frei%20Marcelino%2C%201205%20-%20Rodolfo%20Te%C3%B3filo%2C%20Fortaleza%20-%20CE%2C%2060431-006!5e0!3m2!1spt-BR!2sbr!4v1739715044059!5m2!1spt-BR!2sbr",
    link: "https://tour.meupasseiovirtual.com/view/b3gP3pUFo7Z",
  },
  {
    id: 3,
    nome: "Unidade III",
    tituloPagina: "OFICINA ORTOPÉDICA",
    descricao: "A Sede principal ocupa uma área de cerca de 1.400 m²...",
    telefone: "(85) 3223-4522",
    endereco: "Rua Papi Junior 1225, Rodolfo Teófilo, Fortaleza/CE",
    imagemDetalhe: Unidade3,
    mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.290788135395!2d-38.55478468990992!3d-3.7467104962114544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c7496bc62184c9%3A0xb6601b20024a149a!2sR.%20Papi%20J%C3%BAnior%2C%201045%20-%20Bela%20Vista%2C%20Fortaleza%20-%20CE%2C%2060430-235!5e0!3m2!1spt-BR!2sbr!4v1739715097143!5m2!1spt-BR!2sbr",

    link: "https://tour.meupasseiovirtual.com/view/Y4vAh87RpVP",
  },
  {
    id: 4,
    nome: "Unidade IV",
    tituloPagina: "UNIDADE IV - INTELECTUAL",
    descricao: "A Sede principal ocupa uma área de cerca de 1.400 m²...",
    telefone: "(85) 3223-4522",
    endereco: "Rua Papi Junior 1225, Rodolfo Teófilo, Fortaleza/CE",
    imagemDetalhe: Unidade4,
    mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.290788135395!2d-38.55478468990992!3d-3.7467104962114544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c7496bc62184c9%3A0xb6601b20024a149a!2sR.%20Papi%20J%C3%BAnior%2C%201045%20-%20Bela%20Vista%2C%20Fortaleza%20-%20CE%2C%2060430-235!5e0!3m2!1spt-BR!2sbr!4v1739715169557!5m2!1spt-BR!2sbr",

    link: "https://tour.meupasseiovirtual.com/view/kWDgUD0s0u0",
  },
];
